define([
    'cooperate/component/input-attach',
    'cooperate/api',
    'lodash'
], function(
    InputAttach,
    Api,
    _
){
    return {
        components: {
            InputAttach: InputAttach
        },
        data: function(){
            return {
                form: {},
                attachments: []
            };
        },
        methods: {
            submit: function(){
                var _this = this;
                this.form.attch = _.chain(this.attachments)
                    .map('uploadFilePath')
                    .join(';')
                    .value();
                Api.addCooperateApi.ajax({data_json: JSON.stringify({data: this.form})})
                    .done(function(){
                        _this.resetForm();
                        _this.attachments = [];
                        alert('提交成功');
                    });
            },
            resetForm: function(){
                this.form = {};
            }
        },
        created: function(){
            this.resetForm();
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./cooperate/mixin/form.js
// module id = 114
// module chunks = 0